<template>
  <v-select
      v-bind="$attrs"
      :items="items"
      dense
      outlined
      :clearable="clearable"
      @input="$emit('input', $event !== '' ? $event : null)"
      :error="error"
      :error-messages="error_message"
      :multiple="multiple"
      :itemText="itemText"
      :itemValue="itemValue"
      :returnObject="returnObject"
  >
  </v-select>
</template>

<script>

export default {
  name: 'BaseFieldSelect',
  inheritAttrs: false,
  props: {
    property_state: {default: null},
    property_state_field_name: {default: null},
    clearable: {default: false},
    returnObject: {default: false},
    itemText: {default: null},
    itemValue: {default: null},
    multiple: {default: false},
    items: {default: function() {return []}},
  },

  components: {},

  computed: {
    error() {
      return !!this.property_state && !!this.property_state_field_name && this.property_state[this.property_state_field_name].error
    },
    error_message() {
      if (!!!!this.property_state && !!this.property_state_field_name && this.property_state[this.property_state_field_name].error)
        return this.property_state[this.property_state_field_name].error_message
    else
      return null
    },
  },

  methods: {},

  async mounted() {
  },

  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>
